import axios from 'axios';
import { API_PREFIX, LONG_TIME_OUT } from '@/assets/js/configs';
import { createSource } from '@/assets/js/http';

// eslint-disable-next-line import/prefer-default-export
export function getSampleRanks(rna, analysisId) {
  const url = `${API_PREFIX}/rnas/${rna}/analyses/${analysisId}/sample_ranks`;
  return axios.get(url, {
    timeout: LONG_TIME_OUT,
    cancelToken: (createSource()).token,
  });
}
